module.exports = __webpack_public_path__ + "static/media/gala_show.a7121c89.jpg";